// extracted by mini-css-extract-plugin
export default {"header":"HeaderSimple_header__mlHsT","inner":"HeaderSimple_inner__1WrmU","link":"HeaderSimple_link__dxyh7"};